var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcqIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#f7c17e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.25C10.0188 19.25 9.60677 19.0786 9.26406 18.7359C8.92135 18.3932 8.75 17.9813 8.75 17.5H12.25C12.25 17.9813 12.0786 18.3932 11.7359 18.7359C11.3932 19.0786 10.9812 19.25 10.5 19.25ZM7 16.625V14.875H14V16.625H7ZM7.21875 14C6.2125 13.4021 5.41406 12.6 4.82344 11.5938C4.23281 10.5875 3.9375 9.49375 3.9375 8.3125C3.9375 6.48958 4.57552 4.9401 5.85156 3.66406C7.1276 2.38802 8.67708 1.75 10.5 1.75C12.3229 1.75 13.8724 2.38802 15.1484 3.66406C16.4245 4.9401 17.0625 6.48958 17.0625 8.3125C17.0625 9.49375 16.7672 10.5875 16.1766 11.5938C15.5859 12.6 14.7875 13.4021 13.7812 14H7.21875ZM7.74375 12.25H13.2563C13.9125 11.7833 14.4193 11.2073 14.7766 10.5219C15.1339 9.83646 15.3125 9.1 15.3125 8.3125C15.3125 6.97083 14.8458 5.83333 13.9125 4.9C12.9792 3.96667 11.8417 3.5 10.5 3.5C9.15833 3.5 8.02083 3.96667 7.0875 4.9C6.15417 5.83333 5.6875 6.97083 5.6875 8.3125C5.6875 9.1 5.86615 9.83646 6.22344 10.5219C6.58073 11.2073 7.0875 11.7833 7.74375 12.25Z",
    fill: "#f7c17e "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcqIconActive);
export default __webpack_public_path__ + "static/media/mcqIconActive.eeadf68f498ed2c69439b686c0ff5a52.svg";
export { ForwardRef as ReactComponent };